import MessageBroker from "@bonprix/pattern-library/components/message-broker";
import Messages from '../components/messages';

// Register system events
window.addEventListener('resize', (originalEvent) => {
    MessageBroker.publish(Messages.WINDOW.RESIZED, Object.assign(originalEvent, {
            width: window.innerWidth,
            height: window.innerHeight
    }));
});

window.addEventListener('popstate', (event) => {
    MessageBroker.publish(Messages.HISTORY.BACK, event);
});

window.addEventListener('orientationchange', (event) => {
    MessageBroker.publish(Messages.WINDOW.ORIENTATION_CHANGED, event);
});

if(window.visualViewport) {
    let previousScale = 1.0;
    const viewport = window.visualViewport;
    window.visualViewport.addEventListener('resize', () => {
        const scale = viewport.scale;
        const offsetTop = viewport.offsetTop;
        MessageBroker.publish(Messages.WINDOW.SCALED, { previousScale, scale, offsetTop });
        previousScale = scale;
    });
}

document.onreadystatechange = () => {
    const bodyNode = document.body;
    MessageBroker.publish(Messages.DOM.CHANGED, {
        bodyNode
    });
};
